import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { CheckoutForm, CouponForm, DuplicateCard } from '../../containers';
import { startSubmitSpinner } from '../../redux/actions/interactions';
import { submitSubscription } from '../../redux/actions/subscription';
import { toggleSelectedPlanId } from '../../redux/actions/plans';
import { setSelectedCardSource, toggleShowCards } from '../../redux/actions/cards';
import { getAccessToken } from '../../selectors/auth';
import { getTrialEligibility } from '../../selectors/entitlements';
import { getSelectedPlanId, getPremiumPlans, getTrialPeriodDays } from '../../selectors/plans';
import { getCreditCards, getDefaultSource, getSelectedCard } from '../../selectors/cards';
import config from '../../config';

const promoCodesEnabled = config.funnelConfig ? config.funnelConfig.promoCodesEnabled : null;
class PaymentWrapper extends Component {
  constructor(props) {
    super(props);
    this.handlePromoCodeChange = this.handlePromoCodeChange.bind(this);
    this.state = { promoCode: null };
  }

  componentDidMount() {
    const { viewedCheckout } = this.props;
    viewedCheckout();
  }

  handlePromoCodeChange = (promoCode) => {
    this.setState({ promoCode });
  };

  submitPaymentForm = async (values) => {
    const {
      doSubmitSubscription,
      defaultCardId,
      trialEligible,
      trialPeriodDays,
      accessToken,
      coupon,
      formLocation,
      shouldRedirectToOnboarding,
    } = this.props;
    const { promoCode } = this.state;
    const promotionId = config.funnelConfig ? config.funnelConfig._id : null;
    const subscriptionValues = {
      ...values,
      trialEligible: coupon ? false : trialEligible,
      trialPeriodDays,
      location: formLocation,
      defaultCardId,
      accessToken,
      coupon,
      promotionId,
      promoCodesEnabled,
      promoCode,
      shouldRedirectToOnboarding,
    };
    await doSubmitSubscription(subscriptionValues);
  };

  render() {
    const {
      plans,
      cards,
      selectedCard,
      showCards,
      submitSuccess,
      submitting,
      selectedPlanId,
      doToggleSelectedPlanId,
      doStartSubmitSpinner,
      trialEligible,
      trialPeriodDays,
      subscriptionError,
      cardError,
      showDuplicateCard,
      doSetSelectedCardSource,
      doToggleShowCards,
      showCouponForm = true,
      children,
      coupon,
      enableFunnelPlanTest
    } = this.props;
    const { promoCode } = this.state;
    if (showDuplicateCard) {
      return (
        <DuplicateCard
          submitting={submitting}
          submitPayment={this.submitPaymentForm}
        />
      );
    }

    return (
      <div>
        {children}
        <StripeProvider apiKey={config.stripe.publishableKey}>
          <div>
            <Elements>
              <CheckoutForm
                submitting={submitting}
                submitSuccess={submitSuccess}
                paymentHandler={this.submitPaymentForm}
                triggerSubmit={doStartSubmitSpinner}
                plans={plans}
                cards={cards}
                selectedCard={selectedCard}
                showCards={showCards}
                trialEligible={trialEligible}
                trialPeriodDays={trialPeriodDays}
                selectedPlanId={selectedPlanId}
                toggleSelectedPlanId={doToggleSelectedPlanId}
                error={subscriptionError || cardError}
                doSetSelectedCardSource={doSetSelectedCardSource}
                doToggleShowCards={doToggleShowCards}
                promoCodesEnabled={promoCodesEnabled}
                promoCode={promoCode}
                handlePromoCodeChange={this.handlePromoCodeChange}
                coupon={coupon}
                enableFunnelPlanTest={enableFunnelPlanTest}
              />
            </Elements>
          </div>
        </StripeProvider>
        { showCouponForm ? <CouponForm /> : null}
      </div>);
  }
}

export default connect(
  state => ({
    accessToken: getAccessToken(state),
    trialEligible: getTrialEligibility(state),
    trialPeriodDays: getTrialPeriodDays(state),
    selectedPlanId: getSelectedPlanId(state),
    cards: getCreditCards(state),
    plans: getPremiumPlans(state),
    defaultCardId: getDefaultSource(state),
    selectedCard: getSelectedCard(state),
    queryString: state.routing.location.search,
    submitting: state.interactions.submitting,
    submitSuccess: state.user.submitSuccess,
    showCards: state.cards.showCards,
    showDuplicateCard: state.duplicateCard.showDuplicateCard,
    subscriptionError: state.subscription.error,
    cardError: state.cards.error,
    coupon: state.coupon.coupon,
  }),
  dispatch => ({
    doToggleSelectedPlanId: planId => dispatch(toggleSelectedPlanId(planId)),
    doStartSubmitSpinner: () => dispatch(startSubmitSpinner()),
    doSubmitSubscription: values => dispatch(submitSubscription(values)),
    doSetSelectedCardSource: cardId => dispatch(setSelectedCardSource(cardId)),
    doToggleShowCards: showCards => dispatch(toggleShowCards(showCards)),
  }),
)(PaymentWrapper);
